module.exports = __webpack_public_path__ + "static/media/Check.7f016448.svg";